(function ($, document, window) {
    'use strict';

    $(function () {
        const $trigger = $('.js-modal-trigger');
        const $target = $('.js-modal-target');
        const $close = $('.js-modal-close');
        const $navPrev = $('.js-modal-nav-prev');
        const $navNext = $('.js-modal-nav-next');
        const $bodyOverlay = $('.js-body-overlay');
        const activeClass = 'is-active';
        let currentModalIndex = 0;

        const handleOpen = (e) => {
            e.preventDefault();
            e.stopPropagation();

            // Get the ID from the clicked item's data attributes
            const id = $(e.currentTarget).data('modal');
            currentModalIndex = $trigger.index(e.currentTarget);

            showModal(id);
        }

        const handleClose = () => {
            $target.removeClass(activeClass).attr('aria-hidden', true);
            $('body').removeClass('u-overflow-hidden');
            $bodyOverlay.removeClass(activeClass);
            $bodyOverlay.attr('aria-hidden', true);
            $(document).off('click', handleOutsideClick);
            $(document).off('keydown', handleEscapeKey);
            $trigger.eq(currentModalIndex).blur();
        }

        const handleOutsideClick = (e) => {
            if (!$(e.target).closest($target).length &&
                !$(e.target).closest($trigger).length) {
                handleClose();
            }
        }

        const handleEscapeKey = (e) => {
            if (e.key === 'Escape') {
                handleClose();
            }
        }

        const showModal = (id) => {
            $(`#${id}`).addClass(activeClass).attr('aria-hidden', false);
            $('body').addClass('u-overflow-hidden');
            $bodyOverlay.addClass(activeClass);
            $bodyOverlay.attr('aria-hidden', false);

            setTimeout(() => {
                $(document).on('click', handleOutsideClick);
                $(document).on('keydown', handleEscapeKey);
            }, 0);
        }

        const handleNavPrev = () => {
            if (currentModalIndex > 0) {
                currentModalIndex--;
            } else {
                currentModalIndex = $trigger.length - 1; // Go to the last modal
            }

            const prevId = $trigger.eq(currentModalIndex).data('modal');
            handleClose();
            showModal(prevId);
        }

        const handleNavNext = () => {
            if (currentModalIndex < $trigger.length - 1) {
                currentModalIndex++;
            } else {
                currentModalIndex = 0; // Go to the first modal
            }

            const nextId = $trigger.eq(currentModalIndex).data('modal');
            handleClose();
            showModal(nextId);
        }

        $trigger.on('click', handleOpen);
        $close.on('click', handleClose);
        $navPrev.on('click', handleNavPrev);
        $navNext.on('click', handleNavNext);
    });
})(jQuery, document, window);
